import { useEffect } from 'react'

interface Props {
  codes: string[]
  fn: (code: string) => void
  keys: ('altKey' | 'shiftKey' | 'ctrlKey')[]
}

const useShortcut = ({ codes, fn, keys }: Props): void => {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (codes.includes(event.code) && keys?.every((key) => event[key])) {
        fn(event.code)
      }
    }
    window.addEventListener('keydown', handleKeyPress)

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [codes, keys, fn])
}

export { useShortcut }
